import { CellStatus } from "./primitives";

import { ColumnType, ReportCell } from "@/types/evaluate";

export const getCellValue = (cell?: ReportCell, columnType?: ColumnType) => {
  if (!cell) {
    return null;
  }

  if (cell.status === CellStatus.FAILED) {
    const errorMessage = cell.error_message;

    if (typeof errorMessage === "string") {
      return errorMessage;
    } else if (typeof errorMessage === "object") {
      return JSON.stringify(errorMessage, null, 2);
    }
    return String(errorMessage);
  }

  if (columnType === ColumnType.DATASET) {
    const value = cell.display_value?.value;

    if (!value) {
      return "—";
    }

    if (typeof value === "string") {
      return value;
    } else if (typeof value === "object") {
      return JSON.stringify(value, null, 2);
    }
    return String(value);
  }

  if (columnType === ColumnType.COMPARE) {
    return cell.display_value?.value;
  }

  switch (cell.display_value?.type) {
    case "string":
    case "number":
      return cell.display_value?.value;
    case "object":
      return JSON.stringify(cell.display_value?.value, null, 2);
    case "boolean":
      return cell.display_value?.value ? "true" : "false";
    case "unknown":
      return "—";
    default: {
      const valueType = typeof cell.display_value?.value;

      if (valueType === "object") {
        return JSON.stringify(cell.display_value?.value, null, 2);
      }

      return cell.display_value?.value?.toString();
    }
  }
};
